import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTaskNoPriority = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#515d71",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4 7.25C4.41421 7.25 4.75 7.58579 4.75 8C4.75 8.41421 4.41421 8.75 4 8.75L3 8.75C2.58579 8.75 2.25 8.41421 2.25 8C2.25 7.58579 2.58579 7.25 3 7.25L4 7.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.5 7.25C8.91421 7.25 9.25 7.58579 9.25 8C9.25 8.41421 8.91421 8.75 8.5 8.75L7.5 8.75C7.08579 8.75 6.75 8.41421 6.75 8C6.75 7.58579 7.08579 7.25 7.5 7.25L8.5 7.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 7.25C13.4142 7.25 13.75 7.58579 13.75 8C13.75 8.41421 13.4142 8.75 13 8.75L12 8.75C11.5858 8.75 11.25 8.41421 11.25 8C11.25 7.58579 11.5858 7.25 12 7.25L13 7.25Z",
			fill: "currentColor"
		})
	]
});
export default SvgTaskNoPriority;
